const state = {
  nutri_id: null,
  category_id: null,
  search: null,
  brands: [],
  types: [],
  features: [],
  mall_types: [],
  sort_by: 'norm_amount',
  sort_desc: true,
  with_ship: true,
  amount: "0"
}

// getters
const getters = {
  query: (state, getters) => {
    let query = {}
    if (getters.brands.length > 0)  query.brands = getters.brands.join(',')
    if (getters.types.length > 0) query.types = getters.types.join(',')
    if (getters.features.length > 0) query.features = getters.features.join(',')
    if (getters.mall_types.length > 0) query.mall_types = getters.mall_types.join(',')
    if (state.sort_by) query.sort_by = state.sort_by
    if (state.sort_desc != null) query.sort_desc = state.sort_desc?'true':'false'
    if (state.with_ship != null) query.with_ship = state.with_ship?'true':'false'
    if (state.amount != null) query.amount = state.amount
    return query
  },
  category: (state, getters, rootState) => {
    if (state.category_id && rootState.category.list.length > 0) 
      return rootState.category.list.filter(a => a._id == state.category_id)[0]
    else return null
  },
  nutri: (state, getters, rootState) => {
    if (state.nutri_id && rootState.nutri.list.length > 0) 
      return rootState.nutri.list.filter(a => a._id == state.nutri_id)[0]
    else return null
  },
  amountText: (state) => {
    if (state.amount == 0) return '전체 수량'
    else if (state.amount == 1) return '1개'
    else return `${state.amount}개 이하`
  },
  ...['brands', 'types', 'features', 'mall_types'].reduce((getters, key) => {
    getters[key] = state => {
      return state[key].filter(a => String(a))
    }
    return getters
  }, {})
}

// actions
const actions = {
  async updateFromRoute ({dispatch, commit, state, rootState}, payload) {

    let newState = {}
    let query = payload.query

    newState.brands = query.brands?query.brands.split(','):[]
    newState.types = query.types?query.types.split(','):[]
    newState.features = query.features?query.features.split(','):[]
    newState.mall_types = query.mall_types?query.mall_types.split(','):[]

    newState.sort_by = query.sort_by || 'norm_amount'
    newState.sort_desc = (query.sort_desc || 'true') == 'true'
    newState.with_ship = (query.with_ship || 'true') == 'true'
    newState.amount = query.amount || "0"

    if (payload.type == 'category') {
      if (state.category_id != payload.params.category_id) {
        await dispatch('category/fetchNutritionList', payload.params.category_id, {root: true})
        dispatch('category/fetchBrandList', payload.params.category_id, {root: true})
        payload.query.nutri_id = rootState.nutri.list[0]._id
      }
      if (!payload.query.nutri_id) {
        payload.query.nutri_id = rootState.nutri.list[0]._id
      }
      newState.category_id = payload.params.category_id
      newState.nutri_id = payload.query.nutri_id
      newState.search = null
    }
    else if (payload.type == 'nutri') {
      newState.category_id = null
      newState.nutri_id = payload.params.nutri_id
      newState.search = null
      dispatch('nutri/fetchBrandList', newState.nutri_id, {root: true})
    }
    else if (payload.type == 'search') {
      await dispatch('search/fetchNutritionList', payload.params.search, {root: true})
      dispatch('search/fetchBrandList', payload.params.query, {root: true})
      if (rootState.nutri.list.length > 0) {
        if (!payload.query.nutri_id) {
          payload.query.nutri_id = rootState.nutri.list[0]._id
        }
        newState.nutri_id = payload.query.nutri_id
      }
      newState.category_id = null
      newState.search = payload.params.search
    }
    commit('update', newState)
  }
}

// mutations
const mutations = {
  update (state, newState) {
    Object.assign(state, newState)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/filter.js